"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentDelimiter = void 0;
/**
 * Gets a component delimiter.
 * Defaults to ~.
 * @export
 * @param {(string | undefined)} delimiter
 * @return {*}  {string}
 */
function getComponentDelimiter(delimiter) {
    return delimiter !== null && delimiter !== void 0 ? delimiter : ' ~ ';
}
exports.getComponentDelimiter = getComponentDelimiter;
